<script setup>
import {useProfile} from "~/composables/useProfile.js";

const {changePassword, canChangePass, currentPass, newPass,error, loading} = useProfile()

const canSeeNewPassword = ref(false)
const canSeeCurrentPassword = ref(false)
</script>

<template>
  <form @submit.prevent="changePassword" class="flex flex-col gap-5" autocomplete="off">
    <ul v-if="error.password.length >= 1" class="pl-4 pr-7 py-2 space-y-1 rounded-md bg-red-90/10 border border-red-90/40 list-disc">
      <li class="text-label text-red-90" v-for="(error, index) in error.password" :key="index">{{error}}</li>
    </ul>
    <fieldset>
      <label for="current-pass" class="block text-label mb-2.5">رمز عبور فعلی</label>
      <div class="input-wrapper">
        <input :type="canSeeCurrentPassword ? 'text' : 'password'" id="current-pass" v-model="currentPass" class="input" data-clarity-mask="true" placeholder="******">
        <Icon :name="canSeeCurrentPassword ? 'linear:eye-slash' : 'linear:eye'" class="cursor-pointer" @click="canSeeCurrentPassword = !canSeeCurrentPassword"/>
      </div>
    </fieldset>
    <fieldset>
      <label for="new-pass" class="block text-label mb-2.5">رمز عبور جدید</label>
      <div class="input-wrapper">
        <input :type="canSeeNewPassword ? 'text' : 'password'" id="new-pass" v-model="newPass" class="input" data-clarity-mask="true" placeholder="******">
        <Icon :name="canSeeNewPassword ? 'linear:eye-slash' : 'linear:eye'" class="cursor-pointer" @click="canSeeNewPassword = !canSeeNewPassword"/>
      </div>
    </fieldset>
    <AppBtn class="w-30 btn-sm btn-filled-primary mt-4 mr-auto" :loading="loading.password" :disabled="!canChangePass">
      <span>تفییر رمزعبور</span>
    </AppBtn>
  </form>
</template>

<style scoped>

</style>